module.exports = __webpack_public_path__ + "static/media/REFRACCION.98e47625.png";